import {css} from 'lit-element'; export default css`.autocomplete-empty{padding:1rem 3rem}`;
    